import type { ReactNode } from 'react'
import { cn } from '../../lib/utils'

type TooltipProps = {
  label: string
  children: ReactNode
  className?: string
}

/** Hover/focus tooltip for compact controls (e.g. table icon actions). */
export function Tooltip({ label, children, className }: TooltipProps) {
  return (
    <span className={cn('group/tooltip relative inline-flex', className)}>
      {children}
      <span
        role="tooltip"
        className="pointer-events-none absolute bottom-[calc(100%+6px)] left-1/2 z-[110] -translate-x-1/2 translate-y-1 whitespace-nowrap rounded-md bg-ink-900 px-2.5 py-1.5 text-xs font-medium text-white opacity-0 shadow-lg transition-all duration-150 group-hover/tooltip:translate-y-0 group-hover/tooltip:opacity-100 group-focus-within/tooltip:translate-y-0 group-focus-within/tooltip:opacity-100"
      >
        {label}
        <span
          aria-hidden
          className="absolute left-1/2 top-full -translate-x-1/2 border-[5px] border-transparent border-t-ink-900"
        />
      </span>
    </span>
  )
}
